export default __webpack_public_path__ + "static/media/slime_secretions.1774c07b.png";